import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from '@lingui/core';
import * as parentConstants from '../ProjectDetailsPage/constants';
import * as constants from './constants';
import { NewRheologyPageParams } from './constants';
import useNewRheologyDataQueries, { NewRheologyDataQueries } from '../../shared/NewRheologyPage/useNewRheologyDataQueries';

const NewRheologyPage = lazyWithSuspense(() => import('./NewRheologyPage'));

const title = i18n._('New Rheology Data');
const parentTitle = i18n._('Project Details');

const page: Page = {
  title,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<NewRheologyPageParams, NewRheologyDataQueries>({
    WrappedPage: NewRheologyPage,
    titleFn: () => i18n._(title),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentTitle),
    pageDataHook: useNewRheologyDataQueries,
  }),
};

export default page;
